<template>
  <div class='main-content'>
    <h2 class='main-title'>Liste des exploitations </h2>
    <div class='actions-table flex space-between'>
      <input v-model='filtre' type='text' placeholder='Rechercher...' >
      <div />
      <button v-can:create-exploitation class='action-btn add-btn flex items-center' @click='addExploitation'>Ajouter une exploitation</button>
    </div>
    <table>
      <thead>
        <tr>
          <td>Nom de l'exploitation</td>
          <td>Exploitant</td>
          <td>Département</td>
          <td>Ville</td>
          <td v-can:create-exploitation/>
          <td/>
        </tr>
      </thead>
      <transition-group tag='tbody' name='fade'>
        <tr v-for='exploitation in filteredExploitations' :key='exploitation.id_exploitation'>
          <td>
            <router-link :to='{ name: "exploitation_information", params: { idExploitation: exploitation.id_exploitation }}'>{{ exploitation.nom }}</router-link>
          </td>
          <td>
            <router-link v-if="exploitation.id_exploitant"
              :to='{ name: "exploitation_exploitant", params: { idExploitation: exploitation.id_exploitation }}'>
              {{ exploitation.exploitant_nom }} {{ exploitation.exploitant_prenom }}
            </router-link>
          </td>
          <td>{{ exploitation.departement }}</td>
          <td>{{ exploitation.commune }}</td>
          <td class='align-center' v-can:create-exploitation>
            <button class='action-icon duplicate-btn' @click.prevent='duplicateExploit(exploitation.id_exploitation, exploitation.nom)'/>
          </td>
          <td class='align-center'>
            <button v-can:delete-exploitation="exploitation" class='action-icon delete-btn' @click.prevent='deleteExploit(exploitation.id_exploitation)'/>
          </td>
        </tr>
      </transition-group>
    </table>
    <PromptSimulation
      :show="showDuplicate"
      :exploitation="currentExploitation"
      @cancel="showDuplicate = false"
      @validate="onValidateDuplicate"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PromptSimulation from '@/components/PromptSimulation'

export default {
  name: 'Exploitations',

  components: {
    PromptSimulation
  },

  data () {
    return {
      filtre: '',
      showDuplicate: false,
      currentExploitation: null
    }
  },

  computed: {
    ...mapState({
      exploitations: state => state.exploitations.exploitations,
      isAdmin: state => state.auth.user.role === 'admin',
      idUser: state => state.auth.user.id_user
    }),

    filteredExploitations () {
      return this.exploitations.filter(e => e.nom.toLocaleLowerCase().indexOf(this.filtre.toLocaleLowerCase()) !== -1)
    }
  },

  created () {
    this.loadExploitations()
  },

  methods: {
    ...mapActions(['loadExploitations', 'createExploitation', 'deleteExploitation', 'duplicateExploitation']),
    ...mapActions('confirm', ['confirm']),
    ...mapActions('prompt', ['prompt']),
    ...mapActions('alerte', ['alerte']),
    duplicateExploit (idExploitation, actualName) {
      this.currentExploitation = { idExploitation, actualName }
      this.showDuplicate = true
    },
    onValidateDuplicate ({ idExploitation, nom, idSimulations }) {
      this.showDuplicate = false
      this.duplicateExploitation({ idExploitation, nom, idSimulations })
        .then(newIdExploitation => {
          this.$router.push({ name: 'exploitation_information', params: { idExploitation: newIdExploitation } })
        })
        .catch(_ => {
          this.alerte({
            title: 'Erreur',
            message: "Une erreur s'est produite lors de la duplication.",
            okTest: 'Ok'
          })
        })
    },
    deleteExploit (idExploitation) {
      this.confirm({
        title: 'Suppression Exploitation',
        message: 'Êtes vous-sûr de vouloir supprimer cette exploitation ?',
        okText: 'Supprimer'
      })
        .then(confirmation => {
          if (confirmation) {
            this.deleteExploitation(idExploitation)
              .then(() => this.$store.dispatch('success', 'Exploitation supprimée'))
          }
        })
    },
    addExploitation () {
      this.prompt({
        title: 'Ajout exploitation',
        label: "Nom de l'exploitation",
        okText: 'Créer'
      })
        .then((resultat) => {
          if (resultat !== false) {
            this.createExploitation(resultat)
              .then(newId => this.$router.push({ name: 'exploitation_information', params: { idExploitation: newId } }))
          }
        })
    }
  }
}
</script>

<style scoped>
</style>
